import { Component } from '@angular/core';
import { URLUtils } from '../urlUtils';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../https.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddNotesModalComponent } from '../modal/add-notes-modal/add-notes-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LeadsService } from 'src/app/service/lead.service';


@Component({
  selector: 'app-lead-view',
  templateUrl: './lead-view.component.html',
  styleUrls: ['./lead-view.component.css']
})

export class LeadViewComponent {
  leadId: string = '';
  lead: any;
  notes: any[] = [];
  activeTab = 'details';
  editMode: boolean = false;
  leadForm!: FormGroup;

  specializations:any[] = [];
  //   'Criminal Law', 
  //   'Civil Law', 
  //   'Corporate Law', 
  //   'Family Law', 
  //   'Immigration Law', 
  //   'IP Law',
  //   'Tax Law',
  //   'Real Estate Law',
  //   'Banking Law',
  //   'Other'
  // ];

  countries: string[] = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", 
    "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", 
    "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", 
    "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", 
    "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", 
    "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", 
    "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", 
    "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", 
    "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", 
    "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", 
    "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", 
    "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", 
    "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", 
    "Korea, South", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", 
    "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", 
    "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", 
    "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", 
    "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", 
    "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia", 
    "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", 
    "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", 
    "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", 
    "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", 
    "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", 
    "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", 
    "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", 
    "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", 
    "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", 
    "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", 
    "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", 
    "Zimbabwe"
  ];

  colorClasses = [
    'timeline-blue', 'timeline-orange', 'timeline-green', 
    'timeline-purple', 'timeline-yellow', 'timeline-amber',
    'timeline-cyan', 'timeline-teal', 'timeline-pink'
  ];
  departmentsMap:any[]=[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private leadsService: LeadsService,
    private httpService: HttpService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.initializeForm();

    this.leadsService.currentLead.subscribe(lead => {
      if (lead) {
        this.lead = lead;
        //console.log('get Notes',this.lead)
        this.patchFormValues();
        this.getDept();
      }
    });
    //this.getLeadNotes();

    this.route.params.subscribe(params => {
      this.leadId = params['id'];
      // this.getLeadDetails();
      // this.getLeadNotes();
    });
  }

  getDept() {
  const uid = localStorage.getItem('profuid');
  this.httpService.sendGetRequest(URLUtils.getGroups).subscribe((res: any) => {
    const departments = res.data || [];

    // Clear and repopulate departmentsMap
    this.departmentsMap = [];

    // Filter out 'AAM' and 'SuperUser'
    this.specializations = departments
      .filter((dept: any) => dept.name !== 'AAM' && dept.name !== 'SuperUser')
      .map((dept: any) => {
        this.departmentsMap[dept.id] = dept.name;
        return dept.name === 'I am not sure' ? 'Other' : dept.name;
      });
    //console.log('Departments:', this.specializations);
  });
  }

  getDisplaySubcategory(subs: string[]): string {
    return subs
      .map(spec => this.specializations.includes(spec) ? spec : 'Other')
      .join(', ');
  }  
  
  initializeForm() {
    this.leadForm = this.fb.group({
      fullname: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contact_phone: ['', Validators.pattern('^[0-9]{10}$')],
      contact_person: [''],
      status: [''],
      category: ['', Validators.required],
      subcategory: ['', Validators.required],
      tin: ['', Validators.required],
      designation: [''],
      no_of_lawyers: [0],
      additional_info: [''],
      notes: [''],
      address: this.fb.group({
        address_type: [''],
        house_flat_no: [''],
        street: [''],
        landmark: [''],
        city_town: [''],
        state: [''],
        country: [''],
        zipcode: ['']
      })
    });
  }

  // getLeadDetails() {
  //   this.spinner.show();
  //   this.httpService.sendGetRequest(URLUtils.getLeadList('uid'))
  //     .subscribe({
  //       next: (response: any) => {
  //         this.spinner.hide();
  //         this.lead = response.data;
  //         this.patchFormValues();
  //       },
  //       error: (error) => {
  //         this.spinner.hide();
  //         //this.toastr.error('Failed to load lead details');
  //       }
  //     });
  // }

  getLeadNotes() {
    this.httpService.sendGetRequest(URLUtils.leadslawyers()).subscribe((res: any) => {
      this.lead = res;
      //console.log('res Notes',this.lead)

    });
  }

  patchFormValues() {
    console.log('patch lead',this.lead)
    if (this.lead) {

      this.leadForm.patchValue({
        fullname: this.lead.fullname || '',
        name: this.lead.name || '',
        email: this.lead.email || '',
        contact_phone: this.lead.contact_phone || '',
        status: this.lead.status || '',
        category: this.lead.category || '',
        subcategory: this.lead.subcategory[0] || 'Other',
        tin: this.lead.tin || '',
        designation: this.lead.designation || '',
        contact_person: this.lead.contact_person || '',
        no_of_lawyers: this.lead.no_of_lawyers || 0,
        additional_category: this.lead.additional_category || '',
        additional_info: this.lead.additional_info || '',
        notes: this.lead.notes || '',
        address: {
          address_type: this.lead.address?.address_type || '',
          house_flat_no: this.lead.address?.house_flat_no || '',
          street: this.lead.address?.street || '',
          landmark: this.lead.address?.landmark || '',
          city_town: this.lead.address?.city_town || '',
          state: this.lead.address?.state || '',
          country: this.lead.address?.country || '',
          zipcode: this.lead.address?.zipcode || ''
        }
      });
    }
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    if (!this.editMode) {
      this.patchFormValues(); // Reset form if cancel editing
    }
    //to update subcategory based on lead data
    const leadSubcategory = Array.isArray(this.lead.subcategory) ? this.lead.subcategory[0] : this.lead.subcategory || '';
    const matchedSubcategory = this.specializations.includes(leadSubcategory) ? leadSubcategory : 'Other';
    this.leadForm.patchValue({
      subcategory: matchedSubcategory
    });
  }

  saveChanges() {
    // if (this.leadForm.invalid) {
    //   this.markFormGroupTouched(this.leadForm);
    //   return;
    // }

    const formValues = this.leadForm.value;
    //console.log('formval',formValues)
    
    const address = {
      address_type: formValues.address?.address_type || '',
      house_flat_no: formValues.address?.house_flat_no || '',
      street: formValues.address?.street || '',
      landmark: formValues.address?.landmark || '',
      city_town: formValues.address?.city_town || '',
      state: formValues.address?.state || '',
      country: formValues.address?.country || '',
      zipcode: formValues.address?.zipcode || ''
    };
    //console.log('address',address)

    const payload: any = {
      name: formValues.name,
      fullname: formValues.fullname,
      email: formValues.email,
      contact_phone: formValues.contact_phone,
      contact_person: formValues.contact_person,
      tin: formValues.tin,
      address: address,
      status: formValues.status,
      category: formValues.category, // "entity" or "solo"
      subcategory: [formValues.subcategory],
      // notes_list: formValues.additionalDetails,
      country: formValues.country,
      additional_info: formValues.additional_info,
      no_of_lawyers: formValues.no_of_lawyers,
      designation: formValues.designation,
      id:this.lead.id  
    };
    //console.log('payload',payload)

    this.spinner.show();
    let id = this.lead.id;

    // Use Angular HttpClient to POST
    this.httpService.sendPutRequest(URLUtils.updateLeads(id), payload).subscribe({
      next: (res) => {
        if(res){
          this.toastr.success('Lawyer updated successfully')
                  
          //console.log('leadDetails',this.lead)
          // Update local lead object
          this.lead = {
            ...this.lead,
            ...payload,
            address: {
              ...this.lead.address,
              ...payload.address
            }
          };

          //this.getLeadNotes();
          this.toggleEditMode();
          //console.log('Success:', res);
          //this.activeModal.close(res);
        }else{
          //console.error('Error submitting lead:');
        }
    },
    error: (error) => {
      this.spinner.hide();
      this.toastr.error('Failed to update lawyer.');
      console.error(error);
    },
    complete: () => {
      this.spinner.hide();
    }
  });
  }

  preventMinusPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text') || '';
    if (pastedText.includes('-')) {
      event.preventDefault();
    }
 }

  setActiveTab(tab: 'details' | 'timeline') {
    this.activeTab = tab;
  }

  // addNewNote() {
  //   const modalRef = this.modalService.open(AddNotesModalComponent, {
  //     centered: true,
  //     size: 'md',
  //     backdrop: 'static',    
  //     keyboard: false, 
  //   });
    
  //   modalRef.componentInstance.lead = this.lead;
    
  //   modalRef.result.then((result) => {
  //     if (result) {
  //       this.leadsService.addLead(result);
  //       this.leadsService.currentLead.subscribe(lead => {
  //         this.getLeadNotes();
  //       });
  //     }
  //   }, (reason) => {
  //     // Modal dismissed
  //   });
  // }

  addNewNote() {
    const modalRef = this.modalService.open(AddNotesModalComponent, {
          centered: true,
          size: 'md',
          backdrop: 'static',
          keyboard: false
    });
    modalRef.componentInstance.lead = this.lead;
    modalRef.componentInstance.isQuery = false;
    modalRef.componentInstance.queryId = this.lead.id;
  
    modalRef.result.then((result: any) => {
      if (result) {
        const newNote = {
          add_on: new Date().toISOString(),    // Set today's date
          notes: result.notes,                 // Note title (small heading)
          content: result.note_content,         // Note content (description)
          color: '#4CAF50',                     // Optional: Green color or anything you want
          added_by: 'You'                       // Optional: Current logged-in user
        };
  
        // if (!this.lead.notes_list) {
        //   this.lead.notes_list = [];
        // }
  
        this.lead.notes_list = [...this.lead.notes_list, newNote]; 
      }
    }).catch((err) => {
      //console.log('Modal dismissed', err);
    });
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if ((control as any).controls) {
        this.markFormGroupTouched(control as FormGroup);
      }
    });
  }

  get isEntity() {
    return this.lead.category === 'entity';
  }

  get isLawyer() {
    return this.lead.category === 'solo';
  }
  removeLeadingSpace(event: any,c?:any) {
    const input = event.target;
    input.value = input.value.replace(/^\s+/, '');
    this.leadForm.get(c)?.setValue(input.value, { emitEvent: false });
  }
  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
  
    // Remove invalid characters (allow only numbers)
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
  
    // Prevent leading zeroes
    if (inputElement.value.startsWith('0')) {
      inputElement.value = inputElement.value.substring(1);
    }
  
    // If the first character is still zero, remove it
    this.restrictFirstPosition(event);
    // Add 'has-value' class if the input is not empty (for visual purposes)
    if (inputElement.value) {
      inputElement.classList.add('has-value');
    } else {
      inputElement.classList.remove('has-value');
    }
  }

  restrictFirstPosition(event: any): void {
    const input = event.target.value;
    if (input && input[0] === '0') {
      event.target.value = input.substring(1);  // Remove the leading zero
    }
  }
}
